import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CircularProgress from '@mui/material/CircularProgress';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import PersonIcon from '@mui/icons-material/Person';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CloseIcon from '@mui/icons-material/Close';
import '../Customer/Customer.css';

function CustomerVacating() {
    const { isAuthenticated, companyId, UserId, logout, token } = useAuth();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [successMessages, setSuccessMessages] = useState('');
    const [errorMessages, setErrorMessages] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, UserId, token, logout, id]);

    // Occupied Rooms
    const [occupiedrooms, setOccupiedrooms] = useState([]);
    const fetchtableOCUUPIEDData = async () => {
        try {
            const response = await fetchData('ExpenseApi', `/FilledRooms/${companyId}`, token);
            if (response.responseCode === '1111') {
                setOccupiedrooms(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };

    // Available Rooms
    const [freerooms, setfreerooms] = useState([]);
    const fetchtableFREEData = async () => {
        try {
            const response = await fetchData('CustomerApi', `/RommDetails/${companyId}`, token);
            if (response.responseCode === '1111') {
                setfreerooms(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };

    useEffect(() => {
        fetchtableOCUUPIEDData();
        fetchtableFREEData();
    }, []);

    // Vacating Modal
    const [open, setOpen] = useState(false);
    const [vacatingRooms, setvacatingRooms] = useState({});

    const handleOpen = async (roomId) => {
        setOpen(true);
        try {
            const response = await fetchData('CustomerApi', `/CustomerRoomDetails/${roomId}`, token);
            if (response.responseCode === '1111') {
                setvacatingRooms(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };

    const handleClose = () => {
        setOpen(false);
        setvacatingRooms({});
    };

    // Room Details Modal
    const [roomDetailsopen, setroomDetailsopen] = useState(false);
    const [RoomsDetails, setRoomsDetails] = useState({});

    const handleRoomOpen = async (roomId) => {
        setroomDetailsopen(true);
        try {
            const response = await fetchData('RoomApi', `/CustomerRoomDetails/${roomId}`, token);
            if (response.responseCode === '1111') {
                setRoomsDetails(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching item details:', error);
            if (error.response && error.response.status === 401) {
                logout();
            }
        }
    };

    const handleRoomClose = () => {
        setroomDetailsopen(false);
        setRoomsDetails({});
    };

    // Confirmation Modal
    const [confirmationOpen, setConfirmationOpen] = useState(false);

    const handleVacateClick = () => {
        setConfirmationOpen(true);
    };

    const handleCancel = () => {
        setConfirmationOpen(false);
    };

    const handleConfirmVacate = () => {
        setConfirmationOpen(false);
        VacatingSubmit();
    };

    const VacatingSubmit = async () => {
        setOpen(false);
        setIsLoading(true);
        const updatedFormData = {
            ID: vacatingRooms.CustomerRelationId,
            RoomId: vacatingRooms.RoomId,
            CustomerId: vacatingRooms.CustomerId,
            CreatedDate: vacatingRooms.Createddate,
            BillGenerateDate: vacatingRooms.Rentdate,
            CustomerRentAmount: vacatingRooms.RentAmount,
            CreatedBy: vacatingRooms.UserId,
            UpdatedBy: UserId,
            companyId: companyId,
        };

        try {
            await updateData('ReportApi', `${vacatingRooms.CustomerRelationId}`, updatedFormData, token);
            setSuccessMessages('Vacated successfully!');
            setErrorMessages('');
            setTimeout(() => {
                setSuccessMessages('');
                window.location.reload();
            }, 3000);
        } catch (error) {
            console.error('Error updating record:', error);
            setErrorMessages('Failed to vacate room.');
            setIsLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Not Updated';
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    return (
        <div className="customer-container">
            {/* Loading Overlay */}
            {isLoading && (
                <div className="loading-overlay">
                    <CircularProgress className="loading-spinner" />
                    <span className="loading-text">Processing...</span>
                </div>
            )}

            {/* Messages */}
            {successMessages && (
                <div className="message success" style={{ margin: '0 0 16px 0' }}>{successMessages}</div>
            )}
            {errorMessages && (
                <div className="message error" style={{ margin: '0 0 16px 0' }}>{errorMessages}</div>
            )}

            {/* Occupied Rooms Section */}
            <div className="table-container" style={{ marginBottom: '20px' }}>
                <div className="page-header" style={{ borderLeftColor: '#dc2626' }}>
                    <h1 className="page-title" style={{ color: '#dc2626' }}>
                        <MeetingRoomIcon style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                        Occupied Rooms ({occupiedrooms.length})
                    </h1>
                </div>
                <div className="room-cards-grid">
                    {occupiedrooms && occupiedrooms.length > 0 ? (
                        occupiedrooms.map((item) => (
                            <div
                                key={item.ID}
                                className="room-card"
                                title={item.Name}
                                onClick={() => handleOpen(item.ID)}
                                style={{
                                    background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                                    border: '1px solid #f59e0b',
                                    borderRadius: '8px',
                                    padding: '12px 16px',
                                    height: '50px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(245, 158, 11, 0.3)';
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                                }}
                            >
                                <div style={{ fontWeight: '600', color: '#92400e', fontSize: '14px', textAlign: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {item.Name}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="empty-state" style={{ gridColumn: '1 / -1', padding: '24px' }}>
                            <p>No occupied rooms</p>
                        </div>
                    )}
                </div>
            </div>

            {/* Available Rooms Section */}
            <div className="table-container">
                <div className="page-header" style={{ borderLeftColor: '#059669' }}>
                    <h1 className="page-title" style={{ color: '#059669' }}>
                        <MeetingRoomIcon style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                        Available Rooms ({freerooms.length})
                    </h1>
                </div>
                <div className="room-cards-grid">
                    {freerooms && freerooms.length > 0 ? (
                        freerooms.map((item) => (
                            <div
                                key={item.ID}
                                className="room-card"
                                title={item.Name}
                                onClick={() => handleRoomOpen(item.ID)}
                                style={{
                                    background: 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)',
                                    border: '1px solid #10b981',
                                    borderRadius: '8px',
                                    padding: '12px 16px',
                                    height: '50px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                                }}
                            >
                                <div style={{ fontWeight: '600', color: '#065f46', fontSize: '14px', textAlign: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {item.Name}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="empty-state" style={{ gridColumn: '1 / -1', padding: '24px' }}>
                            <p>No available rooms</p>
                        </div>
                    )}
                </div>
            </div>

            {/* Vacating Modal */}
            {open && (
                <div className="dialog-overlay" onClick={handleClose}>
                    <div className="dialog-box" style={{ maxWidth: '500px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' }}>
                            <h3 className="dialog-title" style={{ margin: 0 }}>Room Details</h3>
                            <button onClick={handleClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748b' }}>
                                <CloseIcon />
                            </button>
                        </div>

                        {vacatingRooms ? (
                            <div style={{ marginBottom: '20px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
                                    <PersonIcon style={{ color: '#64748b', marginRight: '10px' }} />
                                    <span style={{ color: '#64748b', width: '120px' }}>Customer:</span>
                                    <span style={{ fontWeight: '600', color: '#1e3a5f' }}>{vacatingRooms.Customer}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
                                    <MeetingRoomIcon style={{ color: '#64748b', marginRight: '10px' }} />
                                    <span style={{ color: '#64748b', width: '120px' }}>Room:</span>
                                    <span style={{ fontWeight: '600', color: '#1e3a5f' }}>{vacatingRooms.RoomName}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
                                    <CurrencyRupeeIcon style={{ color: '#64748b', marginRight: '10px' }} />
                                    <span style={{ color: '#64748b', width: '120px' }}>Rent Amount:</span>
                                    <span style={{ fontWeight: '600', color: '#059669' }}>₹{vacatingRooms.RentAmount}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
                                    <CalendarTodayIcon style={{ color: '#64748b', marginRight: '10px' }} />
                                    <span style={{ color: '#64748b', width: '120px' }}>Joining Date:</span>
                                    <span style={{ fontWeight: '600', color: '#1e3a5f' }}>{formatDate(vacatingRooms.Joiningdate)}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0' }}>
                                    <CalendarTodayIcon style={{ color: '#64748b', marginRight: '10px' }} />
                                    <span style={{ color: '#64748b', width: '120px' }}>Leaving Date:</span>
                                    <span style={{ fontWeight: '600', color: '#1e3a5f' }}>{formatDate(vacatingRooms.Leavingdate)}</span>
                                </div>
                            </div>
                        ) : (
                            <p>Loading...</p>
                        )}

                        <div className="dialog-actions">
                            <button className="dialog-btn cancel" onClick={handleClose}>Close</button>
                            <button className="dialog-btn confirm" onClick={handleVacateClick}>Vacate Room</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Confirmation Modal */}
            {confirmationOpen && (
                <div className="dialog-overlay" onClick={handleCancel}>
                    <div className="dialog-box" style={{ maxWidth: '400px', textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
                        <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: '#fee2e2', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                            <MeetingRoomIcon style={{ fontSize: '28px', color: '#dc2626' }} />
                        </div>
                        <h3 className="dialog-title" style={{ marginBottom: '8px' }}>Confirm Vacating</h3>
                        <p className="dialog-message">Are you sure you want to vacate this room? This action cannot be undone.</p>
                        <div className="dialog-actions" style={{ justifyContent: 'center' }}>
                            <button className="dialog-btn cancel" onClick={handleCancel}>Cancel</button>
                            <button className="dialog-btn confirm" onClick={handleConfirmVacate}>Yes, Vacate</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Room Details Modal */}
            {roomDetailsopen && (
                <div className="dialog-overlay" onClick={handleRoomClose}>
                    <div className="dialog-box" style={{ maxWidth: '500px' }} onClick={(e) => e.stopPropagation()}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #e2e8f0' }}>
                            <h3 className="dialog-title" style={{ margin: 0 }}>Room Details</h3>
                            <button onClick={handleRoomClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748b' }}>
                                <CloseIcon />
                            </button>
                        </div>

                        {RoomsDetails ? (
                            <div style={{ marginBottom: '20px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
                                    <MeetingRoomIcon style={{ color: '#64748b', marginRight: '10px' }} />
                                    <span style={{ color: '#64748b', width: '120px' }}>Room:</span>
                                    <span style={{ fontWeight: '600', color: '#1e3a5f' }}>{RoomsDetails.Name}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
                                    <span style={{ color: '#64748b', width: '130px', marginLeft: '34px' }}>Description:</span>
                                    <span style={{ fontWeight: '500', color: '#475569' }}>{RoomsDetails.Description || 'N/A'}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', padding: '10px 0' }}>
                                    <CurrencyRupeeIcon style={{ color: '#64748b', marginRight: '10px' }} />
                                    <span style={{ color: '#64748b', width: '120px' }}>Rent Amount:</span>
                                    <span style={{ fontWeight: '600', color: '#059669' }}>₹{RoomsDetails.RentAmount}</span>
                                </div>
                            </div>
                        ) : (
                            <p>Loading...</p>
                        )}

                        <div className="dialog-actions">
                            <button className="dialog-btn cancel" onClick={handleRoomClose}>Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default CustomerVacating;
